import { IconProps } from ".";

export const AgentIcon: React.FC<IconProps> = (props) => {
  return (
    <svg viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        d="M12.3605 14.3354C11.5217 12.4223 11.9755 10.4221 12.9579 8.66357C14.9489 5.09861 12.1805 1.75119 8.52848 1.67003C5.73896 1.60796 2.75334 3.71967 3.43902 6.82643C3.64424 7.75623 2.96538 8.81243 2.48436 9.45857C2.27258 9.74303 2.37931 10.1242 2.71021 10.2518C3.0589 10.3862 3.6022 10.4769 3.68552 10.911C3.81636 11.5924 3.77546 13.1443 4.74744 13.1964L6.73788 13.303C7.71302 13.3552 7.96808 12.4862 8.18995 11.737"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M5.67188 14.3316C5.79897 13.836 5.67188 13.2749 5.67188 13.2749"
        stroke="currentColor"
        strokeLinecap="round"
      />
      <path
        d="M7.54214 4.8501H9.21494C9.79961 4.8501 10.1635 5.26284 10.1635 5.84693V7.423C10.1635 8.00714 9.79961 8.41987 9.21474 8.41987H7.54214C6.95748 8.41987 6.59375 8.00714 6.59375 7.423V5.84693C6.59375 5.26284 6.95921 4.8501 7.54214 4.8501Z"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.19531 4.05615V4.84713"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.57031 4.05615V4.84713"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.19531 8.4187V9.2097"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.57031 8.4187V9.2097"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9628 7.44385H10.1719"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.9628 5.81885H10.1719"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.59567 7.44373H5.80469"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M6.59567 5.81873H5.80469"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
